import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BillingRecurringTypes } from '../models/ss-api/responses/dashboard.license.response';


@Pipe({ name: 'productNameWebSafe' })
export class ProductNameWebSafePipe implements PipeTransform {

    constructor(private _sanitizer: DomSanitizer) {
    }

    transform(productName: string): string {
        let returnName = '';

        switch (productName) {
            case 'VIP3D':
            case 'Vip3D':
                returnName = 'vip3d';
                break;

            case 'Pool Studio':
                returnName = 'poolstudio';
                break;

            case 'VizTerra':
                returnName = 'vizterra';
                break;

            default:
                returnName = 'vip3d';
                break;
        }

        return returnName;
    }

}


@Pipe({ name: 'productName' })
export class ProductNamePipe implements PipeTransform {

    constructor(private _sanitizer: DomSanitizer) {
    }

    transform(productName: string): string {
        let returnName = '';

        switch (productName) {
            case 'VIP3D':
            case 'Vip3D':
                returnName = 'Vip3D';
                break;

            case 'Pool Studio':
                returnName = 'Pool Studio';
                break;

            case 'VizTerra':
                returnName = 'VizTerra';
                break;

            default:
                returnName = 'Vip3D';
                break;
        }

        return returnName;
    }

}


@Pipe({ name: 'billingCycle' })
export class BillingCyclePipe implements PipeTransform {

    constructor(private _sanitizer: DomSanitizer) {
    }

    transform(Recurring: BillingRecurringTypes): string {
        let returnName = '';

        switch (Recurring) {
            case BillingRecurringTypes.Yearly:
                returnName = 'Yearly';
                break;

            case BillingRecurringTypes.Monthly:
                returnName = 'Monthly';
                break;

            default:
                returnName = 'Monthly';
                break;
        }

        return returnName;
    }

}
